import { useCheckReport, useReport } from "@src/common/reliablePartnerApi";
import { useCheckContacts } from "@src/details/detailApi";
import { RPFormattedMessage } from "@src/i18n";
import { CurrentOrgLink } from "@src/MainContent";
import { FC } from "react";

const Notifications = () => {
  const reportOk = useCheckReport();
  const contactsOk = useCheckContacts();

  if (reportOk && contactsOk) {
    return null;
  }

  return (
    <div className="row">
      <div className="col">
        <div className="card mb-6 p-6 bg-light border-0 rounded-0">
          <div className="card-body">
            <h3 className="card-title">
              <RPFormattedMessage
                id="frontPageNotice"
                defaultMessage={"Huomaa nämä:"}
              />
            </h3>
            <ReportNotifications />
            <ContactsNotifications />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;

const ReportNotifications = () => {
  const reportResponse = useReport();

  switch (reportResponse.data?.status) {
    case "incomplete":
      return (
        <div className="alert alert-info" role="alert">
          <i
            className="fa fa-info-circle mr-4 align-self-center"
            aria-hidden="true"
          ></i>
          <RPFormattedMessage
            id="frontPageStatusIncompleteDescription"
            defaultMessage={
              "<b>Tietoja odotetaan</b>-tila raportilla tarkoittaa sitä, että jokin tieto puuttuu tai odotamme tietoja esimerkiksi eläkevakuutusyhtiöltä. Jos raportissa (avattavissa ylläolevasta napista) on jotakin sellaista, josta et ole vielä toimittanut meille tarvittavaa todistusta, voitte ottaa yhteyttä asiakaspalveluumme ja ilmoittaa meille puuttuvat tiedot."
            }
          />
        </div>
      );
    case "investigate":
      return (
        <div className="alert alert-info" role="alert">
          <p>
            <RPFormattedMessage
              id="frontPageStatusInvestigateDescription"
              defaultMessage={
                "<b>Selvitä</b>-tila tarkoittaa, että veronmaksutiedoissa ja/tai eläkevakuutustiedoissa on selvitettävää. Merkinnän poistamiseksi: 1. Ota yhteys Verohallinnon asiakaspalveluun ja/tai eläkevakuutusyhtiöön selvittääksesi merkinnän syy ja sovi tarvittavista maksujärjestelystä. 2. Toimita Vastuu Groupin asiakaspalveluun (<mailToCustomerService>asiakaspalvelu@vastuugroup.fi</mailToCustomerService>) maksutodistukset merkinnän poistamiseksi."
              }
            />
          </p>
        </div>
      );
    case "attention":
      return (
        <div className="alert alert-info" role="alert">
          <p>
            <RPFormattedMessage
              id="frontPageStatusAttentionDescription"
              defaultMessage="<b>Huomioi</b>-tila tarkoittaa, että tilaajan on huomioitava esimerkiksi toimittajan arvonlisäverovelvollisuusrekisteritiedon kohdalla poikkeava sääntö (esim. vapautus rekisteriin kuulumisesta). Yrityksesi eli toimittajan tulisi tilaajan pyynnöstä toimittaa tarvittavat todistukset poikkeuksesta tilaajalle. Tulkinta ei estä työn tilaamista."
            />
          </p>
        </div>
      );
    case "stop":
      return (
        <div className="alert alert-info" role="alert">
          <i
            className="fa fa-info-circle mr-4 align-self-center"
            aria-hidden="true"
          ></i>
          <RPFormattedMessage
            id="frontPageStatusStopDescription"
            defaultMessage="<b>Seis</b>-tila tarkoittaa, että yrityksen kaupparekisteriotteella mainitulla henkilöllä on liiketoimintakielto tai YTJ-tietojen perusteella yritys on lakkautettu, konkurssissa tai toiminta on päättynyt."
          />
        </div>
      );
    default:
      return null;
  }
};

const ContactsNotifications: FC = () => {
  const contactsOk = useCheckContacts();

  if (contactsOk) {
    return null;
  }

  return (
    <div className="alert alert-info mt-6 d-flex" role="alert">
      <div className="d-flex align-items-center">
        <i
          className="fa fa-info-circle mr-4 align-self-center"
          aria-hidden="true"
        ></i>
        <RPFormattedMessage
          id="frontPageReminder"
          defaultMessage={
            "Tarkistathan vielä, että yhteystietonne ovat ajan tasalla."
          }
        />
      </div>

      <div className="ml-auto">
        <CurrentOrgLink
          to="/details/contacts"
          id="reportStatusDetailsLink"
          className="btn btn-primary float-right align-self-center"
        >
          <RPFormattedMessage
            id="frontPageGoToDetails"
            defaultMessage={"Siirry tietoihin"}
          />
        </CurrentOrgLink>
      </div>
    </div>
  );
};
